module.exports = __webpack_public_path__ + "img/progression-map.377cff59.png";